import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Image, Platform, ScrollView, StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';

import Colors from '../../constants/Colors';
import Languages from '../../constants/Languages';
import Layout from '../../constants/Layout';
import * as Actions from '../../store/Actions';
import Header from '../../components/register/Header';
import FilledButton from '../../components/FilledButton';
import PtfKeyboardAvoidingView from '../../components/PtfKeyboardAvoidingView';

import { AppText } from '../../components/AppText';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: Colors.mediumBlue,
  },
  mainContentContainer: {
    flex: 1,
    alignItems: 'center',
    backgroundColor: Colors.white,
  },
  topContainer: {
    flex: 1,
    alignItems: 'center',
  },
  messageContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  buttonContainer: {
    flex: 1,
    flexDirection: 'column',
  },
  headingText: {
    fontSize: Layout.isSmall ? 20 : 26,
    fontWeight: '500',
    color: Colors.veryDarkGray,
    fontFamily: 'roboto-regular',
    textAlign: 'center',
    marginTop: Layout.isSmall ? 53 : 34,
  },
  text: {
    fontFamily: 'roboto-regular',
    fontSize: Layout.isSmall ? 14 : 16,
    color: Colors.veryDarkGray,
    textAlign: 'center',
    marginTop: 16,
    marginBottom: 16,
    width: 328,
  },
  image: {
    height: 101,
    width: 69,
    resizeMode: 'contain',
    marginTop: Layout.isSmall ? 33 : 79,
    marginLeft: -10,
  },
  signupContainer: Layout.signupContainer,
  signupFooter: Layout.signupFooter,
});

class EmailUnsubscribedScreen extends Component {
  static propTypes = {
    registration: PropTypes.objectOf(PropTypes.any).isRequired,
    actions: PropTypes.objectOf(PropTypes.any).isRequired,
    navigation: PropTypes.objectOf(PropTypes.any).isRequired,
  };

  constructor(props) {
    super();
    let unsubscribeCode;
    if (Platform.OS === 'web') {
      const params = new URL(document.location).searchParams;
      unsubscribeCode = params.get('code');
    }
    this.state = {
      unsubscribeEmail: {
        email: null,
        unsubscribed: false,
      },
      updated: false,
      token: unsubscribeCode,
    };
  }

  componentDidMount = () => {
    const { actions } = this.props;
    const { token } = this.state;
    const subscribed = false;
    actions.unsubscribeEmail(token, subscribed);
  };

  componentDidUpdate = () => {
    const { registration } = this.props;
    const { unsubscribeEmail } = registration;
    if (unsubscribeEmail !== this.state.unsubscribeEmail) {
      this.setState({ unsubscribeEmail, updated: true });
    }
  };

  unsubscribe = () => {
    const { actions } = this.props;
    const { token } = this.state;
    const subscribed = false;
    actions.unsubscribeEmail(token, subscribed);
  };

  resubscribe = () => {
    const { actions } = this.props;
    const { token } = this.state;
    const subscribed = true;
    actions.unsubscribeEmail(token, subscribed);
  };

  goToSignin = () => {
    const { navigation } = this.props;
    navigation.navigate('Language');
  };

  goToProfile = () => {
    const { navigation } = this.props;
    navigation.navigate('a', { screen: 'profile' });
  };

  render() {
    const { registration } = this.props;
    const { unsubscribeEmail, updated } = this.state;
    const { language, user } = registration;
    const { email, subscribed } = unsubscribeEmail;
    const translation = Languages.translations[language?.name || 'en'];
    const subscribedMessage = translation.email_subscribed_text.replace('{{email}}', email);
    const unsubscribedMessage = translation.email_unsubscribed_text.replace('{{email}}', email);

    return (
      <SafeAreaView style={{ flex: 1 }} edges={['top', 'left', 'right', 'bottom']}>
        <PtfKeyboardAvoidingView style={{ flex: 1 }}>
          <ScrollView
            keyboardShouldPersistTaps="handled"
            contentContainerStyle={styles.mainContentContainer}
            style={styles.container}
            testID="email-unsubscribed"
          >
            <Header title={translation.email_subscription} />
            <View style={styles.signupContainer}>
              <View style={styles.topContainer}>
                <Image source={require('../../assets/images/sign_up/image_36.png')} style={styles.image} />
                {updated ? (
                  email ? (
                    <View style={styles.messageContainer}>
                      {subscribed ? (
                        <>
                          <AppText style={styles.headingText}>{translation.email_subscribed}</AppText>
                          <AppText style={styles.text}>{subscribedMessage}</AppText>
                          <View style={styles.buttonContainer}>
                            <AppText style={styles.text}>{translation.here_to_unsubscribe}</AppText>
                            <FilledButton
                              onPress={this.unsubscribe}
                              label={translation.unsubscribe}
                              color={Colors.primaryColor}
                              full
                              textColor={Colors.white}
                              disabled={!email}
                              testID="button-unsubscribe"
                            />
                          </View>
                        </>
                      ) : (
                        <>
                          <AppText style={styles.headingText}>{translation.email_unsubscribed}</AppText>
                          <AppText style={styles.text}>{unsubscribedMessage}</AppText>
                          <View style={styles.buttonContainer}>
                            <AppText style={styles.text}>{translation.here_to_subscribe}</AppText>
                            <FilledButton
                              onPress={this.resubscribe}
                              label={translation.subscribe}
                              color={Colors.primaryColor}
                              full
                              textColor={Colors.white}
                              disabled={!email}
                              testID="button-subscribe"
                            />
                          </View>
                        </>
                      )}
                    </View>
                  ) : null
                ) : null}

                {updated ? (
                  user && user.id ? (
                    <View style={styles.buttonContainer}>
                      <AppText style={styles.text}>{translation.open_profile_text}</AppText>
                      <FilledButton
                        onPress={this.goToProfile}
                        label={translation.open_profile}
                        color={Colors.primaryColor}
                        full
                        textColor={Colors.white}
                        disabled={!email}
                        testID="button-profile"
                      />
                    </View>
                  ) : (
                    <View style={styles.buttonContainer}>
                      <AppText style={styles.text}>{translation.sign_in_text}</AppText>
                      <FilledButton
                        onPress={this.goToSignin}
                        label={translation.sign_in}
                        color={Colors.primaryColor}
                        full
                        textColor={Colors.white}
                        disabled={!email}
                        testID="button-signin"
                      />
                    </View>
                  )
                ) : null}
              </View>
            </View>
          </ScrollView>
        </PtfKeyboardAvoidingView>
      </SafeAreaView>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Actions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(EmailUnsubscribedScreen);
